/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Nested Icon component.
 */
export const SystemNestedIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M11.5268 9.47084H3V5' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M10.3687 7.271L12.7062 9.55469L10.3687 11.9998' fill={iconColor} />
    </svg>
  );
};

export default SystemNestedIcon;
